import * as types from './mutation-types'
import { getFichiersImportation, renommerFichierImportation, supprimerFichierImportation } from '../../../api/importation'

const getInitialState = () => {
  return {
    fichiersImportation: {}
  }
}

const state = { ...getInitialState() }

const mutations = {
  [types.SET_FICHIERS_IMPORTATION](state, fichiers) {
    state.fichiersImportation = fichiers
  }
}

const actions = {
  async setFichiersImportation({ commit }) {
    const fichiers = await getFichiersImportation()
    commit(types.SET_FICHIERS_IMPORTATION, fichiers)
  },
  async renommerFichierImportation({ commit, dispatch }, fichier) {
    await renommerFichierImportation(fichier)
    dispatch('setFichiersImportation')
  },
  async supprimerFichierImportation({ commit, dispatch }, fichier) {
    await supprimerFichierImportation(fichier)
    dispatch('setFichiersImportation')
  }
}

const getters = {
  fichiersImportation: state => state.fichiersImportation
}

export default { state, mutations, actions, getters }
